import { formatReportValue } from "@common/helpers/reports";
import { ReportPeriodWithLabel } from "@common/types/reports/types";
import { BaseCellProps } from "@components/spreadsheet/cells";
import { ColumnDef } from "@components/spreadsheet/types";
import { periodField } from "../shared/reportTaskFields";
import { BSSpreadsheetRow } from "./balanceSheetTaskRows";

export type PeriodDrillDownHandler = (
    row: BSSpreadsheetRow,
    idx: number,
) => void;

interface BuildPeriodColumnsParams {
    periods: ReportPeriodWithLabel[];
    onDrillDown?: PeriodDrillDownHandler;
}

export function buildPeriodColumns({
    periods,
    onDrillDown,
}: BuildPeriodColumnsParams): ColumnDef[] {
    return periods.map((period, idx) => ({
        field: periodField(idx),
        label: (
            <span
                style={{
                    display: "block",
                    width: "100%",
                    textAlign: "right",
                }}
            >
                {period.label}
            </span>
        ),
        labelText: period.label,
        isEditable: false,
        width: 140,
        cellFn: ({ value, row }: BaseCellProps) => {
            const bsRow: BSSpreadsheetRow = row;
            const numericValue = typeof value === "number" ? value : null;
            const isDrillDownEnabled =
                onDrillDown !== undefined &&
                (bsRow._accountCodes?.length ?? 0) > 0 &&
                !period.comparisonDiff &&
                !period.ratioType;
            return (
                <span
                    style={{
                        display: "block",
                        width: "100%",
                        textAlign: "right",
                        fontVariantNumeric: "tabular-nums",
                        cursor: isDrillDownEnabled ? "pointer" : undefined,
                    }}
                    role={isDrillDownEnabled ? "button" : undefined}
                    tabIndex={isDrillDownEnabled ? 0 : undefined}
                    onDoubleClick={() => {
                        if (isDrillDownEnabled) {
                            onDrillDown(bsRow, idx);
                        }
                    }}
                    onKeyDown={(e) => {
                        if (
                            isDrillDownEnabled &&
                            (e.key === "Enter" || e.key === " ")
                        ) {
                            e.preventDefault();
                            e.stopPropagation();
                            onDrillDown(bsRow, idx);
                        }
                    }}
                >
                    {numericValue != null
                        ? formatReportValue(numericValue, {
                              comparisonDiff: period.comparisonDiff,
                              ratioType: period.ratioType,
                          })
                        : "-"}
                </span>
            );
        },
    }));
}
